import apiService from './api';

export type NHBLogPayload = {
  role: string;
  robot: string;
  museum: string;
  task: string;
  log: Record<string, unknown>;
};

export const sendNHBLog = async (payload: NHBLogPayload): Promise<unknown> => {
  return apiService.post('/logs/', payload);
};

export type NHBLogQueryParams = {
  limit?: number;
  offset?: number;
  task?: string;
};

export const fetchDashboardUserLogs = async (params: NHBLogQueryParams = {}): Promise<unknown> => {
  const query = new URLSearchParams();
  if (params.limit !== undefined) query.set('limit', String(params.limit));
  if (params.offset !== undefined) query.set('offset', String(params.offset));
  if (params.task) query.set('task', params.task);

  const queryString = query.toString();
  const url = `/logs/${queryString ? `?${queryString}` : ''}`;
  return apiService.get(url);
};
